import { POST } from 'src/network/apiHandler';
import config from 'src/globals';
import { UPLOAD_IMAGE, GET_SIGNED_URL } from './routes';
import { getErrorMessage } from 'src/utils/utils';
import apiProvider from 'src/network/api-provider';
import authHelper from '../auth/auth-helper';

const { API_BASE_URL } = config;

export const getSignedUrlApi = async (url) => {
  return POST(`${API_BASE_URL}${GET_SIGNED_URL}`, { objectUrl: url });
};

export const addFileToSignedUrl = async (putObject: any, file: File) => {
  try {
    const response = await apiProvider.put(putObject.imageSignedUrl, file, {
      headers: {
        'Content-Type': authHelper.dataHeaders[authHelper.getFileExtension(file).toUpperCase()],
      },
    });
    return {
      data: response.data,
      url: putObject.imageUrl,
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getS3SignedUrlAndUploadImage = async (file: File) => {
  try {
    const response = await POST(
      `${API_BASE_URL}${UPLOAD_IMAGE}`,
      {
        fileType: authHelper.dataHeaders[authHelper.getFileExtension(file).toUpperCase()],
        fileName: file.name,
      },
    );
    if (!(response?.data)) {
      return {
        errorMessage: 'Unable to upload image.',
        isSuccess: false,
      };
    }
    const imageUpload = await addFileToSignedUrl(response.data, file);
    return imageUpload;
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
